import { LicenseInfo } from '@mui/x-license';
import ReactGA from 'react-ga';
import { loadConfigFromRootDataset } from './config';
import apiEndpoint from './core/legacy/utils/api';
import { DownloadProvider } from './providers/DownloadProvider';
import { ExternalAiAnalysisProvider } from './providers/ExternalAiAnalysisProvider';
import { ExternalAuthenticationProvider } from './providers/ExternalAuthenticationProvider';
import { ExternalCatalogsProvider } from './providers/ExternalCatalogsProvider';
import { ExternalConfigurationProvider } from './providers/ExternalConfigurationProvider';
import { ExternalNetworkMapProvider } from './providers/ExternalNetworkMapProvider';
import { ExternalOrganizationProvider } from './providers/ExternalOrganizationProvider';
import { ExternalRoadDatasProvider } from './providers/ExternalRoadDatasProvider';
import { ExternalSessionsProvider } from './providers/ExternalSessionsProvider';
import { ExternalTagsProvider } from './providers/ExternalTagsProvider';
import { ExternalUploadProvider } from './providers/externalUploadProvider';
import { initGoogleAnalytics } from './providers/googleAnalyticsProvider';
import { initI18n } from './providers/i18nProvider';
import { IntervalProvider } from './providers/IntervalProvider';
import MapViewSettingsProvider from './providers/MapViewSettingsProvider';
import { initSentry } from './providers/sentryProvider';
import { SerializableFileProvider } from './providers/SerializableFileProvider';
import { StorageProvider } from './providers/StorageProvider';
import { TimeProvider } from './providers/TimeProvider';
import { createStore } from './store';
import { buildUi } from './ui';

import './design/global';
import { ExternalNetworkConfigurationProvider } from './providers/ExternalNetworkConfigurationProvider';
import { ExternalNetworkProvider } from './providers/ExternalNetworkProvider';
import { ExternalProjectConfigurationProvider } from './providers/ExternalProjectConfigurationProvider';
import { ExternalProjectProvider } from './providers/ExternalProjectProvider';
import { ExternalReferenceConfigurationProvider } from './providers/ExternalReferenceConfigurationProvider';
import { ExternalReferenceProvider } from './providers/ExternalReferenceProvider';

import theme from './design/theme';
(window as any).__RC_THEME__ = theme;

LicenseInfo.setLicenseKey(import.meta.env.VITE_DATAGRID_LICENSE_KEY!);

// Config
const config = loadConfigFromRootDataset();
const baseEndpoint = apiEndpoint!;

// Providers
const isProduction = initSentry(config.sentryDsn, config.sentryEnvironment);
initGoogleAnalytics(config.googleAnalyticsTag);
initI18n(isProduction);

// Store
const { store, history } = createStore({
    externalAuthentication: new ExternalAuthenticationProvider(baseEndpoint),
    externalAiAnalysis: new ExternalAiAnalysisProvider(baseEndpoint),
    externalSessions: new ExternalSessionsProvider(baseEndpoint),
    externalSessionConfiguration: new ExternalConfigurationProvider(),
    externalInterval: new IntervalProvider(),
    externalUpload: new ExternalUploadProvider(baseEndpoint),
    time: new TimeProvider(),
    download: new DownloadProvider(),
    serializableFileProvider: new SerializableFileProvider(),
    storageProvider: new StorageProvider(),
    externalCatalogs: new ExternalCatalogsProvider(baseEndpoint),
    externalRoadDatas: new ExternalRoadDatasProvider(baseEndpoint),
    externalNetworkMap: new ExternalNetworkMapProvider(baseEndpoint),
    mapViewSettings: new MapViewSettingsProvider(),
    externalTags: new ExternalTagsProvider(baseEndpoint),
    externalOrganization: new ExternalOrganizationProvider(baseEndpoint),
    externalReference: new ExternalReferenceProvider(baseEndpoint),
    externalReferenceConfiguration: new ExternalReferenceConfigurationProvider(),
    externalNetwork: new ExternalNetworkProvider(baseEndpoint),
    externalNetworkConfiguration: new ExternalNetworkConfigurationProvider(),
    externalProject: new ExternalProjectProvider(baseEndpoint),
    externalProjectConfiguration: new ExternalProjectConfigurationProvider(),
});
history.listen((update) => ReactGA.pageview(update.location.pathname));

// Ui
buildUi(isProduction, store, history);
